import * as React from "react";
import "./PreOrderInsider.css";
import Chip from "@mui/material/Chip";
import filterIcon from "../../Assets/Icons/Vector.png";
import Stack from "@mui/material/Stack";
import SortIcon from "@mui/icons-material/Sort";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Avatar from "@mui/material/Avatar";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../image/ayekart logo.png";
import { Box } from "@mui/system";
import { ListItemIcon, Popover } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Logout from "@mui/icons-material/Logout";
import { removeToken } from "../../redux/tokenSlice";
import authService from "../../services/auth.service";
import { useSelector, useDispatch } from "react-redux";
import toast, { Toaster } from "react-hot-toast";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useState } from "react";
import { NavBar } from "../Navbar/NavBar";
import { useEffect } from "react";
import moment from "moment";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import axios from "axios";
import { Typography } from "@mui/material";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import Loader from "../Loader";
import { useForm } from "react-hook-form";
import Sidebar from "../Sidebar";

export default function PreOrderInsider() {
  const history = useNavigate();
  const loc = useLocation();
  console.log(loc);
  const token = localStorage.getItem("token");
  const [singleBatch, setSingleBatch] = useState([]);

  const handleDelete = (chipToDelete) => () => {
    // setChipData((chips) =>
    //   chips.filter((chip) => chip.key !== chipToDelete.key)
    // );
  };
  const userDetails = JSON.parse(localStorage.getItem("user_detail"));
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const [ordersData, setOrdersData] = useState({});
  const [reson, setReson] = useState("");
  const [dummy, setDummy] = useState(false);

  // ----------------------------API calls----------------------
  const getOrdersInBatch = () => {
    setLoading(true);
    let data = fetch(
      `/workflow/api/bulk/batches/${loc?.state}?start=0&length=500`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (res?.status === true) {
          setOrdersData(res?.batches);
          setLoading(false);
        }
      });
  };

  const approvePreOrder = async () => {
    setLoading(true);
    let level_user = userDetails?.email_address;
    const obj = { batch_id: loc?.state };
    if (level_user === "pranav@ayekart.com") {
      if (singleBatch?.level_1_status === "Approved") {
        return toast.error("Already approved");
      }
      axios
        .patch("/workflow/api/bulk/lvl1/approve", obj, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((res) => {
          if (res?.data?.status === true) {
            toast.success(res?.data?.message);
            setDummy(!dummy);
            setLoading(false);
          } else {
            toast?.error(res?.data?.message);
            setLoading(false);
          }
        });
      handleCloseAcceptModal();
    } else if (level_user === "kalpesh@ayekart.com") {
      if (singleBatch?.level_2_status === "Approved") {
        return toast.error("Already approved");
      }
      axios
        .patch("/workflow/api/bulk/lvl2/approve", obj, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((res) => {
          if (res?.data?.status === true) {
            toast.success(res?.data?.message);
            setLoading(false);
            setDummy(!dummy);
          } else {
            toast?.error(res?.data?.message);
            setLoading(false);
          }
        });
      handleCloseAcceptModal();
    }

    if (level_user === "siddesh@gmail.com") {
      setLoading(true);
      if (singleBatch?.level_3_status === "Approved") {
        return toast.error("Already approved");
      }
      axios
        .patch("/workflow/api/bulk/lvl3/approve", obj, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((res) => {
          if (res?.data?.status === true) {
            toast.success(res?.data?.message);
            setLoading(false);
            setDummy(!dummy);
          } else {
            toast?.error(res?.data?.message);
            setLoading(false);
          }
        });
      handleCloseAcceptModal();
    } else {
      toast.error("Access denied");
      setLoading(false);
      handleCloseAcceptModal();
    }
  };

  const rejectPreOrder = async () => {
    if (reson === "") {
      return toast.error("Enter reson");
    }
    let level_user = userDetails?.email_address;
    const obj = { batch_id: loc?.state, reason: reson };
    if (level_user === "pranav@ayekart.com") {
      if (singleBatch?.level_1_status === "Approved") {
        return toast.error("Already approved");
      } else if (singleBatch?.level_1_status === "Rejected") {
        return toast.error("Already Rejected");
      }
      axios
        .patch("/workflow/api/bulk/lvl1/reject", obj, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((res) => {
          if (res?.data?.status === true) {
            toast.success(res?.data?.message);
            setDummy(!dummy);
          } else {
            toast.error(res?.data?.message);
          }
        });
      handleCloseRejectModal();
      setReson("");
    } else if (level_user === "kalpesh@ayekart.com") {
      if (singleBatch?.level_2_status === "Approved") {
        return toast.error("Already approved");
      } else if (singleBatch?.level_1_status !== "Approved") {
        return toast.error(
          "Can't Reject this grid of pre-orders until Level_1 approves the Grid"
        );
      } else if (singleBatch?.level_2_status === "Rejected") {
        return toast.error("Already Rejected");
      }
      axios
        .patch("/workflow/api/bulk/lvl2/reject", obj, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((res) => {
          if (res?.data?.status === true) {
            toast.success(res?.data?.message);
            setDummy(!dummy);
          } else {
            toast.error(res?.data?.message);
          }
        });
      handleCloseRejectModal();
      setReson("");
    } else if (level_user === "siddesh@gmail.com") {
      if (singleBatch?.level_3_status === "Approved") {
        return toast.error("Already approved");
      } else if (singleBatch?.level_1_status !== "Approved") {
        return toast.error(
          "Can't Reject this grid of pre-orders until Level_1 approves the Grid"
        );
      } else if (singleBatch?.level_2_status !== "Approved") {
        return toast.error(
          "Can't Reject this grid of pre-orders until Level_2 approves the Grid"
        );
      } else if (singleBatch?.level_3_status === "Rejected") {
        return toast.error("Already Rejected");
      }
      axios
        .patch("/workflow/api/bulk/lvl3/reject", obj, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((res) => {
          if (res?.data?.status === true) {
            toast.success(res?.data?.message);
            setDummy(!dummy);
          } else {
            toast.error(res?.data?.message);
          }
        });
      handleCloseRejectModal();
      setReson("");
    } else {
      toast.error("Access denied");
      handleCloseRejectModal();
      setReson("");
    }
  };

  const exportFile = () => {
    axios
      .get(`/workflow/api/bulk/batches/export/${loc?.state}`, {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const type = response.headers["content-type"];
        const blob = new Blob([response.data], {
          type: type,
          encoding: "UTF-8",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `Batch_no_${loc?.state}.csv`;
        link.click();
      });
  };

  const getSingleBatch = () => {
    let data = fetch(
      `/workflow/api/bulk/batches?type=search&batch_id=${loc?.state}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (res?.status === true) {
          setSingleBatch(res?.batches?.rows[0]);
        }
      });
  };
  console.log(singleBatch);
  // ---------------------API calls ends here-------------------

  useEffect(() => {
    getOrdersInBatch();
    getSingleBatch();
  }, [dummy]);

  //------------Modal states -----------------------------------
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const handleCloseAcceptModal = () => setShowAcceptModal(false);
  const handleShowAcceptModal = () => setShowAcceptModal(true);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const handleCloseRejectModal = () => setShowRejectModal(false);
  const handleShowRejectModal = () => setShowRejectModal(true);
  const [stsReason, setStsReason] = useState("");
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  // ------------------------------------------------------------

  const [anchorPop, setAnchorPop] = React.useState(null);

  const handlePopoverOpen = (event, resn, sts) => {
    setAnchorPop(event.currentTarget);
    console.log(sts);
    if (sts === "Approved") {
      setStsReason("Approved");
    } else if (sts === "Pending") {
      setStsReason("Pending");
    } else {
      setStsReason(resn ? `Reason: ${resn}` : "--NA--");
    }
  };

  const handlePopoverClose = () => {
    setAnchorPop(null);
  };

  const openPop = Boolean(anchorPop);

  // -------------------PO / BOS----------------------------//

  const [preOrderId, setPreOrderId] = useState(0);
  const [PoImg, setPoImg] = useState("");
  const [bosImg, setBosImg] = useState("");
  const PoFileOnchange = (e) => {
    setPoImg(e.target.files[0]);
    console.log(e.target.files[0]);
  };

  const BosFileOnchange = (e) => {
    setBosImg(e.target.files[0]);
    console.log(e.target.files[0]);
  };

  const handlePOUpload = async (dataFile) => {
    setLoading(true);
    if (PoImg === "") {
      setLoading(false);
      return toast.error("Please select file");
    }
    const formData = new FormData();
    formData.append("file", PoImg);
    const token = localStorage.getItem("token");
    const res = await fetch(`/workflow/api/bulk/pre_order/po/${preOrderId}`, {
      method: "PATCH",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    })
      .then((res) => res.json())
      .then((res) => {
        if (res?.status === false) {
          toast.error(res?.message);
          setLoading(false);
        } else {
          toast.success(res?.message);
          setLoading(false);
          setPoImg("");
        }
      });
  };

  const handleBOSUpload = async (dataFile) => {
    setLoading(true);
    if (bosImg === "") {
      setLoading(false);
      return toast.error("Please select file");
    }
    const formData = new FormData();
    formData.append("file", bosImg);
    const token = localStorage.getItem("token");
    const res = await fetch(`/workflow/api/bulk/pre_order/bos/${preOrderId}`, {
      method: "PATCH",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    })
      .then((res) => res.json())
      .then((res) => {
        if (res?.status === false) {
          toast.error(res?.message);
          setLoading(false);
        } else {
          toast.success(res?.message);
          setLoading(false);
          setBosImg("");
        }
      });
  };

  return (
    <div className=" ">
      <div className="mt-3  ">
        <Loader loading={loading} />
        <div className=" ">
          <div className="container-fluid ">
            <div className="row">
              <div className="col-12 ps-0 text-start">
                <h5>
                  <KeyboardDoubleArrowLeftIcon
                    role="button"
                    className="text-secondary mr-2"
                    onClick={() => history(`/pre-order-list`)}
                  />
                  Batch-ID-{loc?.state}
                </h5>
              </div>
            </div>
          </div>

          <div className="container-fluid p-0 mb-2">
            <div className="row mx-0 mt-1">
              <div className="col col-sm-12 col-md-6 col-lg-6 d-flex pl-0 text-left pt-2 pb-2">
                <div
                  className="levels-card w-25 pt-3 pb-2 "
                  role="button"
                  onMouseEnter={(e) =>
                    handlePopoverOpen(
                      e,
                      singleBatch?.lvl_1_corrections,
                      singleBatch?.level_1_status
                    )
                  }
                  onMouseLeave={handlePopoverClose}
                >
                  <div className="row mx-0  ">
                    <div className="col col-sm-3 col-md-3 col-lg-3 d-flex align-items-center justify-content-center">
                      <div className="L1 w-auto ps-2 pe-2 pt-1 pb-1 fw-bold">
                        L1
                      </div>
                    </div>
                    <div className="col col-sm-9 col-md-9 col-lg-9 d-flex flex-column text-start">
                      <span className="lh-1 color-0c3094 fw-bold">
                        Level 1 Status
                      </span>
                      <small
                        className={
                          singleBatch?.level_1_status === "Approved"
                            ? "text-success"
                            : "text-warning"
                        }
                      >
                        {singleBatch?.level_1_status}
                      </small>
                    </div>
                  </div>
                </div>
                <div
                  className="levels-card w-25 pt-3 pb-2"
                  role="button"
                  onMouseEnter={(e) =>
                    handlePopoverOpen(
                      e,
                      singleBatch?.lvl_2_corrections,
                      singleBatch?.level_2_status
                    )
                  }
                  onMouseLeave={handlePopoverClose}
                >
                  <div className="row mx-0">
                    <div className="col col-sm-3 col-md-3 col-lg-3 d-flex align-items-center justify-content-center">
                      <div className="L2 w-auto ps-2 pe-2 pt-1 pb-1 fw-bold">
                        L2
                      </div>
                    </div>
                    <div className="col col-sm-9 col-md-9 col-lg-9 d-flex flex-column text-start">
                      <span className="lh-1 color-0c3094 fw-bold">
                        Level 2 Status
                      </span>
                      <small
                        className={
                          singleBatch?.level_2_status === "Approved"
                            ? "text-success"
                            : "text-warning"
                        }
                      >
                        {singleBatch?.level_2_status}
                      </small>
                    </div>
                  </div>
                </div>
                <div
                  className="levels-card w-25 pt-3 pb-2"
                  role="button"
                  onMouseEnter={(e) =>
                    handlePopoverOpen(
                      e,
                      singleBatch?.lvl_3_corrections,
                      singleBatch?.level_3_status
                    )
                  }
                  onMouseLeave={handlePopoverClose}
                >
                  <div className="row mx-0">
                    <div className="col col-sm-3 col-md-3 col-lg-3 d-flex align-items-center justify-content-center">
                      <div className="L3 w-auto ps-2 pe-2 pt-1 pb-1 fw-bold">
                        L3
                      </div>
                    </div>
                    <div className="col col-sm-9 col-md-9 col-lg-9 d-flex flex-column text-start">
                      <span className="lh-1 color-0c3094 fw-bold">
                        Level 3 Status
                      </span>
                      <small
                        className={
                          singleBatch?.level_3_status === "Approved"
                            ? "text-success"
                            : "text-warning"
                        }
                      >
                        {singleBatch?.level_3_status}
                      </small>
                    </div>
                  </div>
                </div>
                <Popover
                  id="mouse-over-popover"
                  sx={{
                    pointerEvents: "none",
                  }}
                  open={openPop}
                  anchorEl={anchorPop}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  onClose={handlePopoverClose}
                  disableRestoreFocus
                >
                  <Typography sx={{ p: 1 }}>{stsReason}</Typography>
                </Popover>
              </div>

              {userDetails?.email_address === "pranav@ayekart.com" &&
              (singleBatch?.level_1_status === "Pending" ||
                singleBatch?.level_1_status === "Corrections Done") ? (
                <div className="col col-sm-12 col-md-6 col-lg-6 d-flex justify-content-end   pt-2 pb-2">
                  <div
                    className="accept-reject-btn-style me-3 bg-68C750 color-0c3094 text-light accept-btn"
                    role="button"
                    onClick={handleShowAcceptModal}
                  >
                    Accept <TaskAltIcon sx={{ ml: 3 }} />
                  </div>
                  <div
                    className="accept-reject-btn-style bg-DA5930 color-0c3094 text-light reject-btn"
                    role="button"
                    onClick={handleShowRejectModal}
                  >
                    Reject <HighlightOffIcon sx={{ ml: 3 }} />
                  </div>
                </div>
              ) : userDetails?.email_address === "kalpesh@ayekart.com" &&
                (singleBatch?.level_2_status === "Pending" ||
                  singleBatch?.level_2_status === "Corrections Done") ? (
                <div className="col col-sm-12 col-md-6 col-lg-6 d-flex justify-content-end   pt-2 pb-2">
                  <div
                    className="accept-reject-btn-style me-3 bg-68C750 color-0c3094 text-light accept-btn"
                    role="button"
                    onClick={handleShowAcceptModal}
                  >
                    Accept <TaskAltIcon sx={{ ml: 3 }} />
                  </div>
                  <div
                    className="accept-reject-btn-style bg-DA5930 color-0c3094 text-light reject-btn"
                    role="button"
                    onClick={handleShowRejectModal}
                  >
                    Reject <HighlightOffIcon sx={{ ml: 3 }} />
                  </div>
                </div>
              ) : userDetails?.email_address === "siddesh@gmail.com" &&
                (singleBatch?.level_3_status === "Pending" ||
                  singleBatch?.level_3_status === "Corrections Done") ? (
                <div className="col col-sm-12 col-md-6 col-lg-6 d-flex justify-content-end   pt-2 pb-2">
                  <div
                    className="accept-reject-btn-style me-3 bg-68C750 color-0c3094 text-light accept-btn"
                    role="button"
                    onClick={handleShowAcceptModal}
                  >
                    Accept <TaskAltIcon sx={{ ml: 3 }} />
                  </div>
                  <div
                    className="accept-reject-btn-style bg-DA5930 color-0c3094 text-light reject-btn"
                    role="button"
                    onClick={handleShowRejectModal}
                  >
                    Reject <HighlightOffIcon sx={{ ml: 3 }} />
                  </div>
                </div>
              ) : singleBatch?.level_1_status === "Approved" &&
                singleBatch?.level_2_status === "Approved" &&
                singleBatch?.level_3_status === "Approved" ? (
                <div className="col col-sm-12 col-md-6 col-lg-6 d-flex justify-content-end   pt-2 pb-2">
                  <div
                    className="accept-reject-btn-style pl-3 pr-3 me-3 bg-68C750 color-0c3094 text-light accept-btn"
                    role="button"
                    onClick={() =>
                      history(`/final-orders`, {
                        state: loc?.state,
                      })
                    }
                  >
                    View Final Orders
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div class="order-list-container">
            <div className="list-table mt-2">
              <table class="table">
                <thead class="color-0c3094 header" style={{backgroundColor:'#00213e'}}>
                  <tr>
                    <th class="header text-start" scope="col">
                      Pre-Order Date
                    </th>
                    <th class="header text-start" scope="col">
                      Pre-Order ID
                    </th>
                    <th class="header text-start" scope="col">
                      Buyer Name
                    </th>
                    <th class="header text-start" scope="col">
                      Supplier Name
                    </th>
                    <th class="header text-start" scope="col">
                      Total CP
                    </th>
                    <th class="header text-start" scope="col">
                      Total SP
                    </th>
                    <th class="header text-start" scope="col">
                      Margin
                    </th>
                    <th class="header text-center" scope="col">
                      Payment Method
                    </th>
                    <th class="header text-center" scope="col">
                      PO
                    </th>
                    <th class="header text-center" scope="col">
                      BOS
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {ordersData && ordersData?.rows?.length > 0 ? (
                    ordersData?.rows?.map((item, index) => (
                      <React.Fragment key={index}>
                        <tr className="list-table-row">
                          <td>
                            {moment(item?.updated_at).format("DD/MM/yyyy")}
                          </td>
                          <td>{item?.pre_order_id}</td>
                          <td>{item?.buyer_name}</td>
                          <td>{item?.supplier_name}</td>
                          <td>₹ {Number(item?.total_cp).toFixed(2)} </td>
                          <td className=" ">
                            ₹ {Number(item?.total_sp).toFixed(2)}
                          </td>
                          <td className=" ">
                            ₹{" "}
                            {(
                              Number(item?.total_sp).toFixed(2) -
                              Number(item?.total_cp).toFixed(2)
                            ).toFixed(2)}
                          </td>
                          <td className="text-success fw-bold text-center">
                            {item?.payment_method
                              ? item?.payment_method
                              : "Supply Chain Finance"}
                          </td>
                          <td className="text-center">
                            <button
                              type=""
                              className="btn btn-primary p-0 px-3 btn-sm"
                              data-bs-toggle="modal"
                              data-bs-target={`#uploadPOModal${index}`}
                              onClick={() => setPreOrderId(item?.pre_order_id)}
                            >
                              <small>Upload</small>
                            </button>{" "}
                            <span>|</span>{" "}
                            <button
                              type=""
                              className="btn btn-primary p-0 px-3 btn-sm"
                              // data-bs-toggle="modal"
                              // data-bs-target={`#uploadBOSModal${index}`}
                              // onClick={() => setPreOrderId(item?.pre_order_id)}
                            >
                              <small>Download</small>
                            </button>
                            <span>|</span>{" "}
                            <button
                              type=""
                              className="btn btn-primary p-0 px-3 btn-sm"
                              // data-bs-toggle="modal"
                              // data-bs-target={`#uploadBOSModal${index}`}
                              // onClick={() => setPreOrderId(item?.pre_order_id)}
                            >
                              <small>View</small>
                            </button>
                          </td>

                          <td className="text-center">
                            <button
                              type=""
                              className="btn btn-primary p-0 px-3 btn-sm"
                              data-bs-toggle="modal"
                              data-bs-target={`#uploadBOSModal${index}`}
                              onClick={() => setPreOrderId(item?.pre_order_id)}
                            >
                              <small>Upload</small>
                            </button>{" "}
                            <span>|</span>{" "}
                            <button
                              type=""
                              className="btn btn-primary p-0 px-3 btn-sm"
                            >
                              <small>Download</small>
                            </button>
                            <span>|</span>{" "}
                            <button
                              type=""
                              className="btn btn-primary p-0 px-3 btn-sm"
                              // data-bs-toggle="modal"
                              // data-bs-target={`#uploadBOSModal${index}`}
                              // onClick={() => setPreOrderId(item?.pre_order_id)}
                            >
                              <small>View</small>
                            </button>
                          </td>

                          {/* ------------Modal for Upload PO------------- */}
                          <div
                            className="modal fade"
                            id={`uploadPOModal${index}`}
                            data-bs-backdrop="static"
                            data-bs-keyboard="false"
                            tabIndex="-1"
                            aria-labelledby={`uploadPOModal${index}`}
                            aria-hidden="false"
                          >
                            <div className="modal-dialog">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h1
                                    className="modal-title fs-5"
                                    id={`uploadPOModal${index}`}
                                  >
                                    Upload PO
                                  </h1>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                  ></button>
                                </div>

                                <div className="modal-body">
                                  <div className="row form-group">
                                    <label
                                      htmlFor="date"
                                      className="col-sm-4 col-form-label pt-1"
                                    >
                                      Select File
                                    </label>
                                    <div className="col-sm-8 pl-0 text-left">
                                      <input
                                        name="fileCSV"
                                        type="file"
                                        accept=".csv,.xlsx,.jpg,.pdf"
                                        onChange={(e) => PoFileOnchange(e)}
                                      />
                                    </div>
                                  </div>
                                  <div className="row d-flex justify-content-center text-danger">
                                    {errors?.po_file
                                      ? errors?.po_file?.message
                                      : ""}
                                  </div>
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                  >
                                    Close
                                  </button>
                                  <button
                                    type="submit"
                                    className="btn btn-primary"
                                    onClick={() => handlePOUpload()}
                                    data-bs-dismiss={PoImg ? "modal" : ""}
                                  >
                                    Upload
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* -----------Modal for Upload PO ends here---- */}
                          {/* ------------Modal for Upload BOS------------- */}
                          <div
                            className="modal fade"
                            id={`uploadBOSModal${index}`}
                            data-bs-backdrop="static"
                            data-bs-keyboard="false"
                            tabIndex="-1"
                            aria-labelledby={`uploadBOSModal${index}`}
                            aria-hidden="false"
                          >
                            <div className="modal-dialog">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h1
                                    className="modal-title fs-5"
                                    id={`uploadBOSModal${index}`}
                                  >
                                    Upload BOS
                                  </h1>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                  ></button>
                                </div>
                                <div className="modal-body">
                                  <div className="row form-group">
                                    <label
                                      htmlFor="date"
                                      className="col-sm-4 col-form-label pt-1"
                                    >
                                      Select File
                                    </label>
                                    <div className="col-sm-8 pl-0 text-left">
                                      <input
                                        name="fileCSV"
                                        type="file"
                                        accept=".csv,.xlsx,.pdf,.jpg"
                                        onChange={(e) => BosFileOnchange(e)}
                                      />
                                    </div>
                                  </div>
                                  <div className="row d-flex justify-content-center text-danger">
                                    {errors?.file ? errors?.file?.message : ""}
                                  </div>
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                  >
                                    Close
                                  </button>
                                  <button
                                    type="submit"
                                    className="btn btn-primary"
                                    onClick={() => handleBOSUpload()}
                                    data-bs-dismiss={bosImg ? "modal" : ""}
                                  >
                                    Upload
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* -----------Modal for Upload BOS ends here---------*/}
                        </tr>
                      </React.Fragment>
                    ))
                  ) : (
                    <>No Records</>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="container-fluid p-0 mt-2">
            <div className="row mx-0  ">
              <div className="col-9 text-left">
                {/* <span>Showing 1 to 8 of 70</span> */}
              </div>
              <div className="col-3 text-right pe-0">
                <button
                  type="button"
                  className="btn btn-primary ps-4 pe-4 bg-0C3094"
                  onClick={() => exportFile()}
                >
                  <FileUploadIcon sx={{ mr: 1 }} />
                  Export
                </button>
              </div>
            </div>
          </div>
        </div>
        <Modal show={showAcceptModal} onHide={handleCloseAcceptModal}>
          <Modal.Header closeButton>
            <Modal.Title className="color-0c3094 fw-bold fs-3">
              Accept Order
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="container text-center">
              <TaskAltIcon sx={{ height: 100, width: 100, color: "green" }} />
            </div>
            <h4 className="color-0c3094 fw-bold text-center mt-3">
              Are you sure,want to approve this grid of pre-orders?
            </h4>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center">
            <Button variant="secondary" onClick={handleCloseAcceptModal}>
              Cancel
            </Button>
            <Button variant="primary" onClick={approvePreOrder}>
              Yes, Accept
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showRejectModal} onHide={handleCloseRejectModal}>
          <Modal.Header closeButton>
            <Modal.Title className="color-0c3094 fw-bold fs-3">
              Reject Order
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="container text-center">
              <HighlightOffIcon
                sx={{ height: 100, width: 100, color: "red" }}
              />
            </div>
            <div className="container text-center">
              <form>
                <div class="mb-3">
                  <div className="row mx-0 d-flex text-start">
                    <label
                      for="exampleInputPassword1"
                      class="form-label fw-bold"
                    >
                      Reson :
                    </label>
                  </div>
                  <input
                    type="text"
                    value={reson}
                    class="form-control"
                    id="exampleInputPassword1"
                    placeholder="Enter valid reson"
                    onChange={(e) => setReson(e.target.value)}
                  />
                </div>
              </form>
            </div>
            <h4 className="color-0c3094 fw-bold text-center mt-3">
              Are you sure,want to Reject this grid of pre-orders?{" "}
            </h4>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center">
            <Button variant="secondary" onClick={handleCloseRejectModal}>
              Cancel
            </Button>
            <Button variant="primary" onClick={rejectPreOrder}>
              Yes, Reject
            </Button>
          </Modal.Footer>
        </Modal>

        <Toaster />
      </div>
    </div>
  );
}
